// extracted by mini-css-extract-plugin
export default {"wrap":"MheuQ","card":"k35hU"};